import lowerCase from 'lodash/lowerCase';
import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import constants from '@/constants';
import capitalize from 'lodash/capitalize';
import i18n from '@/plugins/i18n';

const ResponseUtil = {

  constants: {
    badRequestResponseCode: 400,
    unauthorizedResponseCode: 403,
    conflictResponseCode: 409,
    messages: {
      clockOutCollision: 'Clock-out already recorded for time pair:',
    },
  },

  getTimeRequestErrorMessage(response, timePair = null, creating = true) {
    const typeText = lowerCase((!isEmpty(timePair) && has(timePair, 'pairType')) ? timePair.pairType
      : constants.TimePairType.SHIFT);

    if (!response) {
      // Note that this likely means that there is a issue on the front end
      // and not what was returned
      return i18n.t('dialogs.error.causes.frontEndError');
    }

    switch (response.status) {
      case this.constants.badRequestResponseCode:
        return response.data.message;

      case this.constants.unauthorizedResponseCode:
        return i18n.t('dialogs.error.causes.notAuthorizedToSubmit', { type: typeText });

      case this.constants.conflictResponseCode:
        return this.handleConflict(response.data);

      default:
        return i18n.t('dialogs.error.causes.unknownResponse', {
          type: capitalize(typeText),
          action: creating ? i18n.t('misc.saved') : i18n.t('misc.deleted'),
          status: response.status,
        });
    }
  },

  handleConflict(data) {
    if (
      data
      && typeof data === 'object'
      && 'isShiftTimePairCompleted' in data
    ) {
      return data.message;
    }

    return i18n.t('dialogs.error.causes.clockInAbsenceCollision');
  },

  shouldResetClockOnError(exception) {
    return !!exception.includes('Clock-out already recorded for time pair');
  },

};

export default ResponseUtil;
